import { render, staticRenderFns } from "./SearchWizard.vue?vue&type=template&id=a9b51158&scoped=true"
import script from "./SearchWizard.vue?vue&type=script&lang=js"
export * from "./SearchWizard.vue?vue&type=script&lang=js"
import style0 from "./SearchWizard.vue?vue&type=style&index=0&id=a9b51158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b51158",
  null
  
)

export default component.exports